import { TRIP } from "@/data/content";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

export default function TripDetails() {
  return (
    <section data-testid="trip-details-section" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <span className="overline">Upcoming Trip</span>
            <h2 className="font-serif text-4xl md:text-5xl text-navy mt-3 leading-[1.05] tracking-tight">
              {TRIP.title}
            </h2>
            <div className="mt-4 flex items-center gap-3">
              <span className="gold-divider" />
              <span className="text-sm text-[var(--maqam-muted)]">{TRIP.dateRange}</span>
            </div>
            <p className="mt-6 text-[var(--maqam-muted)] leading-relaxed">
              A community-led journey to the two holy cities, designed with care from the
              spiritual program down to the smallest logistical detail.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-4">
              <div className="card-elevated rounded-lg p-5">
                <p className="overline">Madinah</p>
                <p className="font-serif text-2xl text-navy mt-1">5 nights</p>
                <p className="text-xs text-[var(--maqam-muted)] mt-1">5-star · near Masjid an-Nabawi</p>
              </div>
              <div className="card-elevated rounded-lg p-5">
                <p className="overline">Makkah</p>
                <p className="font-serif text-2xl text-navy mt-1">5 nights</p>
                <p className="text-xs text-[var(--maqam-muted)] mt-1">5-star · steps from the Haram</p>
              </div>
            </div>

            <Link
              to="/umrah-october-2026"
              data-testid="trip-details-view-btn"
              className="mt-8 inline-flex items-center btn-primary rounded-full px-6 py-3 font-semibold"
            >
              Full Itinerary &amp; Pricing
            </Link>
          </div>

          <div className="lg:col-span-7">
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {TRIP.highlights.map((h, i) => (
                <li
                  key={i}
                  data-testid={`trip-highlight-${i}`}
                  className="card-elevated rounded-lg p-4 flex items-start gap-3"
                >
                  <span className="mt-1 inline-flex items-center justify-center w-6 h-6 rounded-full bg-gold/90" style={{background:'var(--maqam-gold)'}}>
                    <Check size={14} className="text-navy" />
                  </span>
                  <span className="text-sm text-[var(--maqam-ink)] leading-relaxed">{h}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
